import axios from "axios";
import { getAuth } from "firebase/auth";
import Premium from "../models/Premium.js";
import GenerateCoverLetterEntity from "../models/GenerateCoverLetterEntity.js";

const BASE_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net";

export default class PremiumService {
  // Получение текущей подписки
  static async fetchMySubscription() {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
  
      if (!currentUser) {
        throw new Error(
          "Пользователь не авторизован"
        );
      }
  
      const token =
        await currentUser.getIdToken(true);
  
      const response = await axios.get(
        `${BASE_URL}/get_my_subscription`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
  
      console.log(
        "🔍 RAW get_my_subscription:",
        response.data
      );
  
      const raw =
        response.data?.subscription ??
        response.data;
  
      if (!raw) {
        console.warn(
          "⚠️ Сервер не вернул данные Premium"
        );
  
        return null;
      }
  
      const premium = Premium.fromJson(raw);
  
      console.log(
        "📦 Premium mapped:",
        premium.toJSON()
      );
  
      return premium;
    } catch (error) {
      console.error(
        "❌ Ошибка get_my_subscription:",
        error.response?.data ||
        error.message
      );
  
      throw error;
    }
  }

  // 🔹 Создание платежа
  static async createPayment(planKey) { 
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);

      const response = await axios.post(
        `${BASE_URL}/create_payment_v2`,
        { plan: planKey },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("💰 Платёж успешно создан:", response.data);

      return {
        paymentUrl: response.data.payment_url,
        invoiceId: response.data.invoice_id,
        amount: response.data.amount,
      };
    } catch (error) {
      console.error("❌ Ошибка при создании платежа:", error.message);
      throw error;
    }
  }

  // 🆕 Генерация сопроводительного письм
static async generateCoverLetter(companyId) {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) throw new Error("Пользователь не авторизован");

    const token = await currentUser.getIdToken(true);

    const response = await axios.post(
      `${BASE_URL}/generate_cover_letter`,
      { company_id: companyId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    const aiJson = response.data?.result;
    if (!aiJson) throw new Error("Invalid AI response");

    return GenerateCoverLetterEntity.fromJson(aiJson);

  } catch (error) {
    console.error("❌ Error generating cover letter:", error);
    throw error;
  }
}

  // 🆕 Отправка письма работодателю
static async sendCoverLetter(companyId, letter) {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) throw new Error("Пользователь не авторизован");

    const token = await currentUser.getIdToken(true);

    const response = await axios.post(
      `${BASE_URL}/send_cover_letter`,
      {
        company_id: companyId,
        title: letter.title,
        body: letter.body,
        reasons: letter.reasons,
        closing: letter.closing
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    return response.data;

  } catch (error) {
    console.error("❌ Error sending cover letter:", error);
    throw error;
  }
}

static async aiResumeParse(file) {
  const auth = getAuth();
  const currentUser = auth.currentUser;

  if (!currentUser) {
    throw new Error("Пользователь не авторизован");
  }

  const token = await currentUser.getIdToken(true);

  const formData = new FormData();
  formData.append("file", file);  

  const response = await axios.post(
    `${BASE_URL}/parse_resume`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
}


static async fillInResumePremium() {

  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      throw new Error("Пользователь не авторизован");
    }
    const token = await currentUser.getIdToken(true);
    const response = await axios.post(
      `${BASE_URL}/generate_about_me`,
      {}, // тело пустое
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );
    console.log("🤖 AI about generated:", response.data);
    return response.data; // { text: "..." }
  } catch (error) {
    console.error("❌ Ошибка fill_in_resume_premium:", error);
    // можно прокинуть более понятную ошибку
    if (error.response?.status === 403) {
      throw new Error("Требуется Premium подписка");
    }
    throw error;
  }
}

}


function fileToBase64(file) {

  return new Promise((resolve, reject) => {

    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {

      const base64 = reader.result.split(",")[1];

      resolve(base64);

    };

    reader.onerror = (error) => reject(error);

  });

}